module.exports = __webpack_public_path__ + "static/media/7.09137d59.jpg";